import { WebEDIAnnotation } from 'services/webediErrors/types';
import portalSchema from 'support/types/schema-portal';

import { MapAnnotationContext } from './mapAnnotation';
import { memoizedMapAnnotation } from './memoizeMapAnnotation';

type Annotation = portalSchema.components['schemas']['Annotation'];

type BuildAnnotationItemsArgs = MapAnnotationContext & {
  annotations: Array<Annotation> | undefined;
};

export const buildAnnotationItems = ({
  annotations,
  canonical,
  flattenData,
  uiConfig,
}: BuildAnnotationItemsArgs): Array<WebEDIAnnotation> => {
  if (!annotations || annotations.length === 0) {
    return [];
  }
  const items: Array<WebEDIAnnotation> = [];
  for (const annotation of annotations) {
    const item = memoizedMapAnnotation(annotation, { canonical, flattenData, uiConfig });
    if (item) {
      items.push(item);
    }
  }
  return items;
};
